import clsx from 'clsx';

/**
 * Shared visual language for the worklist section/sequence tab-bars.
 *
 * The Confirmations worklist and the Ops worklist both answer the same
 * question — "which pile am I working?" — so their top tabs should read as the
 * same control. This is the single source of truth for that shape: a square
 * (rounded-md) bordered pill, gold by default with red/green tone variants for
 * the escalated / done piles. Callers own the label + count child; this only
 * styles the button shell so the two surfaces stop diverging.
 */
export type WorklistTabTone = 'gold' | 'red' | 'green';

export function worklistTabClass(active: boolean, tone: WorklistTabTone = 'gold'): string {
  return clsx(
    'inline-flex items-center gap-2 px-4 py-2 rounded-md border font-inter text-sm transition',
    !active && 'border-gold-dim/40 text-cream-soft hover:border-gold-bright/50',
    active && tone === 'gold' && 'border-gold-bright text-gold-bright bg-gold-bright/10',
    active && tone === 'red' && 'border-blood text-blood bg-blood/10',
    active && tone === 'green' && 'border-mint text-mint bg-mint/10',
  );
}
